export { default as HearingAndVisionImpairmentsV2 } from './impl/HearingAndVisionImpairmentsV2.jsx';


// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/entities/items/HearingAndVisionImpairmentsV2/index.jsx